/**
 * Utility functions for handling drag and drop events
 */

/**
 * Handle drag over event - adds visual feedback
 */
export const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
    event.currentTarget.classList.add('drag-over');
};

/**
 * Handle drag leave event - removes visual feedback
 */
export const handleDragLeave = (event) => {
    event.preventDefault();
    event.stopPropagation();
    event.currentTarget.classList.remove('drag-over');
};

/**
 * Handle drop event and extract file
 * @param {DragEvent} event
 * @returns {File|null} The dropped file or null
 */
export const handleFileDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    event.currentTarget.classList.remove('drag-over');

    const files = event.dataTransfer.files;
    if (files && files.length > 0) {
        return files[0];
    }
    return null;
};

/**
 * Handle drop event and extract ALL files (for bulk upload)
 * @param {DragEvent} event
 * @returns {File[]|null} Array of dropped files or null
 */
export const handleMultiFileDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    event.currentTarget.classList.remove('drag-over');

    const files = event.dataTransfer.files;
    if (files && files.length > 0) {
        return Array.from(files);
    }
    return null;
};
